/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioFabricantesCV from './controladorVista/formularioFabricantesCV';
import TablaFabricantesCV from './controladorVista/tablaFabricantesCV';
import { estadoIncial, reductor } from './reductorFabricantes';

const Fabricantes: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaFabricantesCV />
        <FormularioFabricantesCV />
    </ProveedorEstado>
);

export default Fabricantes;
